module.exports = __webpack_public_path__ + "img/photo_dirty_octo.8b34c29e.jpeg";